<template>
  <header></header>
  <div class="out_box">
    <div class="detail_content" v-loading="isLoading">
      <div class="title_detail">
        <div class="header_title">
          {{ currentMessage.title }}
        </div>
        <div class="desc">{{ $t('common.email.releaseTime')}}：{{ currentMessage.sendTime || currentMessage.createTime }}</div>
      </div>
      <div class="content_detail">
        <iframe style="width: 100%;height: 100%;overflow: scroll" frameborder="0"
                :srcdoc="currentMessage?.content"></iframe>
      </div>
    </div>
  </div>
</template>


<script setup>
import Header from "@/components/Header/Header.vue";
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";

const store = useStore()
const route = useRoute()
const currentMessage = computed(() => store.state.message.currentMessage)
const isLoading = ref(false)
const getCurrentDetail = async () => {
  const payload = {
    id: route.query.id
  }
  try {
    isLoading.value = true
    await store.dispatch("message/messageQueryById", payload)
    isLoading.value = false
  } catch (e) {
    isLoading.value = false
  }
}

onMounted(async () => {
  await getCurrentDetail()
})
</script>

<style lang="less" scoped>
.out_box {
  height: calc(100vh - 48px);
  width: 100vw;
  background: #F5F5F5;
  //background: red;
  padding-top: 20px;


  .detail_content {
    background: white;
    max-width: 1200px;
    width: auto;
    min-width: 640px;
    height: calc(100vh - 85px);
    border-radius: 5px;
    //height: 200px;
    //background: red;
    margin: 0px auto 0px;
    padding: 20px 20px 0px 20px;
  }

  .title_detail {
    padding: 10px 0px 0px 0px;
    text-align: center;
    border-bottom: 1px solid grey;

    .header_title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
    }

    .desc {
      margin-top: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      margin-bottom: 20px;
    }
  }

}

.content_detail {
  margin-top: 10px;
  height: calc(100% - 125px);

  iframe {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
</style>